import Page from '../page';
import FormValidator from '../../helpers/form-validator';
import Google from '../../helpers/google';

export default class RegisterIndex extends Page {
	constructor(...args) {
		super(...args);

        this._action = 'candiapro_register';
		this._is_process = false;
		this.objectValues = {};

		this._processListener = {
			secondProcess: this._secondProcess.bind(this),
			prevProcess: this._prevProcess.bind(this),
			process: this._process.bind(this),
		};

		this._retrieveDOM();
		this._initTls();

		this.FormValidator = new FormValidator({
			inputs: this.dom.formInput
		});
	}

	_retrieveDOM() {
		super._retrieveDOM();

		// Inputs
		this.dom.formInput = this.dom.page.querySelectorAll('.js-form-input');
		this.dom.formSelect = this.dom.page.querySelectorAll('.js-form-select');
		this.dom.password = this.dom.page.querySelector('.js-password');
		this.dom.confirmPassword = this.dom.page.querySelector('.js-confirm-password');
		this.dom.optNewsletter = this.dom.page.querySelector( '.js-form-opt-newsletter' );

		// brands
		this.dom.brands = this.dom.page.querySelectorAll('.js-brands-line');
		this.dom.brand = this.dom.page.querySelectorAll('.js-brand');
		this.dom.free = this.dom.page.querySelectorAll('.js-free-brand');
		
		// Process
		this.dom.send = this.dom.page.querySelector('.js-btn-send');
		this.dom.error = this.dom.page.querySelector('.js-error-message');
		this.dom.next = this.dom.page.querySelector('.js-btn-next');
		this.dom.prev = this.dom.page.querySelector('.js-btn-prev');
		this.dom.secondForm = this.dom.page.querySelector('.second-process');
		this.dom.firstForm = this.dom.page.querySelector('.first-process');
		this.dom.containerTitle = this.dom.page.querySelector('.position-title');
		this.dom.brandTitle = this.dom.containerTitle.querySelector('.title-brand');
	}

	bind() {
		super.bind();

		this.dom.next.addEventListener('click', this._processListener.process);
		this.dom.confirmPassword.addEventListener('blur', this._checkPassword.bind(this));

		for (let i = 0; i < this.dom.brand.length; i++) {
			const el = this.dom.brand[i];
			el.addEventListener('click', this._toggleBrand.bind(this, el));
		}
		for (let i = 0; i < this.dom.formSelect.length; i++) {
			const el = this.dom.formSelect[i];
			el.addEventListener('change', this._checkSelect.bind(this, el));
		}
	}

	// PROCESS
	_process() {
		if( this._is_process == false ) {

            this.dom.error.classList.remove('show');
			this._is_process = true;

			let vForm = this.FormValidator.isValid();
			let vSelects = this._checkSelects();
			let vPass = this._checkPassword();

			if ( vForm && vSelects && vPass ) {

				this.objectValues = this.FormValidator.getData();

				for (let i = 0; i < this.dom.formSelect.length; i++) {
					let el = this.dom.formSelect[i];
					let cat = el.getAttribute('data-cat');
					this.objectValues[cat] = el.value;
				}

				// Get Option Newsletter
                this.objectValues[ 'opt_newsletter' ] = ( this.dom.optNewsletter.checked ) ? true : false;

				//Change Form
				this.dom.secondForm.style.display = 'block';
				this.dom.firstForm.style.display = 'none';

				// Change form style
				this.dom.brandTitle.classList.remove('enabled');
				this.dom.send.classList.remove('enabled');
				this.dom.prev.classList.remove('hidden');
				this.dom.next.classList.add('hidden');
				this.dom.containerTitle.classList.add('brand');

				//Event for second form
				this.dom.send.addEventListener('click', this._processListener.secondProcess);
				this.dom.prev.addEventListener('click', this._processListener.prevProcess);

			} else {
				this._is_process = false;
			}
		}
	}

	_secondProcess(){

		let brands = {};
		for (let i = 0; i < this.dom.brands.length; i++) {
			let el = this.dom.brands[i];
			let cat = el.getAttribute('data-cat');
			brands[cat] = this._pushBrands(cat);
		}

		this.objectValues['brands'] = brands;

		this._request( this.objectValues );
	}

	_prevProcess(){
		this._is_process = false;

		this.dom.containerTitle.classList.remove('brand');
		this.dom.brandTitle.classList.add('enabled');
		this.dom.send.classList.add('enabled');
		this.dom.next.classList.remove('hidden');
		this.dom.prev.classList.add('hidden');

		this.dom.secondForm.style.display = 'none';
		this.dom.firstForm.style.display = 'block';

		this.dom.send.removeEventListener('click', this._processListener.secondProcess);

	}

	_request( values ) {
		console.log('request');
        // Format data
        var data = new FormData();
        data.append( 'data', JSON.stringify( values ));

        document.body.classList.add('loading');
        this.dom.send.classList.add('loading');
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/ajax.php?action=' + this._action, true);
        xhr.onreadystatechange = function () {
            console.log(xhr);
            if(xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
                this._response( (JSON.parse(xhr.response) ));
            }
        }.bind(this);
        xhr.send(data);
    }


    _response( response ) {

        document.body.classList.remove('loading');
		this.dom.send.classList.remove('loading');
		this._is_process = false;

		// Request succeed
        if( response.success == true ) {
            Google.pushCustomTracker('Subscribe', 'Send');
            this.dom.container.querySelector('.strate-2').classList.add('success');
            // this.dom.body.querySelector('.js-replace-email').innerHTML = this.dom.email.value;
        }

        // Request failed
        if( response.success == false ) {

            if( response.data.error == 'existed_email' ) {
                this.dom.error.innerHTML = response.data.error_message;
                this.dom.error.classList.add('show');

            }
        }
    }

	// HELPERS & CHECKS
	_pushBrands(cat) {
		let arrayBrands = [];
		for (let i = 0; i < this.dom.brand.length; i++) {
			const el = this.dom.brand[i];
			if (el.getAttribute('data-cat') == cat && el.classList.contains('active')) {
				arrayBrands.push(el.getAttribute('data-brand'));
			}
		}

		let freeInput = this.dom.page.querySelector('.js-free-brand[data-cat="'+cat+'"]');
		if (freeInput.value != '') {
			let values = freeInput.value.split(',');
			for (let i = 0; i < values.length; i++) {
				arrayBrands.push(values[i].trim());
			}
		}

		return arrayBrands;
	}
	
	_checkSelect(el) {
		if (el.value == '') {
			el.classList.add('error');
			el.classList.remove('success');
			return false;
		} else {
			el.classList.remove('error');
			el.classList.add('success');
			return true;
		}
	}

	_checkSelects() {
		let valid = true;
		for (let i = 0; i < this.dom.formSelect.length; i++) {
			const el = this.dom.formSelect[i];
			if (this._checkSelect(el) == false)
				valid = false;
		}

		return valid;
	}

	_checkPassword() {
		if ((this.dom.confirmPassword.value !== this.dom.password.value) || (this.dom.confirmPassword.value == '')) {
			this.dom.confirmPassword.classList.add('error');
			return false;
		} else {
			this.dom.confirmPassword.classList.remove('error');
			return true;
		}
	}

	_toggleBrand(el) {
		el.classList.toggle('active');
	}

	/**
	 * init() {}
	 * bind() {}
	 * unbind() {}
	 * resize(width, height) {}
	 * _destroy() {}
	 */
}



// WEBPACK FOOTER //
// ./src/js/pages/register/register-index.js